import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { IngredientsDataService, IngredientsColumnsService } from '../../../services';
import { Ingredient, IngredientsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-ingredient-details',
  templateUrl: './ingredient-details.component.html',
  styleUrls: ['./ingredient-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class IngredientDetailsComponent implements OnInit, OnDestroy {

  public ingredient: Ingredient = {};
  public ingredients: Ingredient[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ingredientsDataService: IngredientsDataService,
    private ingredientsColumnsService: IngredientsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Ingredient - Details');
        this.getIngredient(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ingredient !== 'undefined') {
      this.ingredient = this.dynamicDialogConfig.data.ingredient;
    }
    this.columns = this.ingredientsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getIngredient(id: number): void {
    this.isLoading = true;
    this.ingredientsDataService.getIngredient(id).subscribe((response: Ingredient|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ingredient = response;
      }
    });
  }

  list() {
    this.router.navigate(['/ingredients']);
  }

  add() {
    this.router.navigate(['/ingredients/add']);
  }

  edit() {
    this.router.navigate(['/ingredients/edit/' + this.ingredient.id]);
  }

}
@Component({
  selector: 'app-ingredient-details',
  templateUrl: './ingredient-details.component.html',
  styleUrls: ['./ingredient-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogIngredientDetailsComponent extends IngredientDetailsComponent {
}

